import { LogOut, ChevronRight, Shield } from 'lucide-react';
import Tooltip from '../../ToolTip';
import useModal from '../../../hooks/modalHook';
import ActionConfirmation from '../../elements/ActionConfirmation';
import useUserAccount from '../../../hooks/userAccountHook';

interface SidebarFooterProps {
  isSidebarExpanded: boolean;
  onLogout: () => void;
  onToggleSidebar: () => void;
}

export default function SidebarFooter({ isSidebarExpanded, onLogout, onToggleSidebar }: SidebarFooterProps) {
  const { ModalComponent, closeModal, updateModalStates } = useModal();

  return (
    <>
      <div className={`border-t bg-white dark:bg-darkBg border-gray-200 dark:border-darkBg-border ${isSidebarExpanded ? 'p-4' : 'p-2'}`}>
        <div className={`w-full flex ${isSidebarExpanded ? 'flex-row justify-between' : 'flex-col items-center'}`}>
          <Tooltip message="Logout">
            <div className="w-full">
              <button
                onClick={onLogout}
                className={`flex items-center w-full px-3 py-2 text-sm font-medium text-gray-600 dark:text-darkBg-subText rounded-md hover:text-gray-900 dark:hover:text-darkBg-mainText hover:bg-gray-50 dark:hover:bg-darkBg-border transition-colors ${isSidebarExpanded ? '' : 'justify-center'}`}
                title={isSidebarExpanded ? '' : 'Logout'}
              >
                <LogOut className='h-5 w-5' />
                {isSidebarExpanded && <span className="ml-3">Logout</span>}
              </button>
            </div>
          </Tooltip>

          <Tooltip message={isSidebarExpanded ? 'Collapse sidebar' : 'Expand sidebar'}>
            <div className="w-full">
              <button
                onClick={onToggleSidebar}
                className="flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-darkBg-border transition-colors"
                title={isSidebarExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
              >
                <ChevronRight className={`h-5 w-5 text-gray-600 dark:text-darkBg-subText transition-transform duration-300 ${isSidebarExpanded ? 'rotate-180' : ''}`} />
              </button>
            </div>
          </Tooltip>
        </div>

        {isSidebarExpanded && (
          <>
            <div className="mt-4 flex items-center justify-center">
              <div className="flex items-center space-x-1.5 text-xs text-gray-500 dark:text-darkBg-subText">
                <span>Powered by</span>
                <div className="flex items-center">
                  <Shield className="h-3.5 w-3.5 text-gray-700 dark:text-darkBg-mainText" />
                  <span className="ml-1 font-semibold text-gray-700 dark:text-darkBg-mainText">Brolly</span>
                </div>
              </div>
            </div>
            <div className="mt-1 text-center text-xs text-gray-400 dark:text-darkBg-subText">
              &copy; {new Date().getFullYear()} Brolly Africa
            </div>
          </>
        )}
      </div>
      <ModalComponent />
    </>
  );
}
